import { createSlice } from '@reduxjs/toolkit';
import { documentAction } from '../actions';
import { documentReducer as extraReducers } from '../reducers';
import { IDocumentState } from '../../interfaces';

const initialState: IDocumentState = {
  status: 'inactive',
  categories: null,
  error: '',
};

export const documentSlice = createSlice({
  name: 'document',
  initialState,
  // Non-async reducers
  reducers: {
    resetDocument: () => {
      return initialState;
    },
  },
  // Async reducers
  extraReducers,
});

// Action creators are generated for each case reducer function
export const documentSliceActions = { ...documentSlice.actions, ...documentAction };

export default documentSlice.reducer;
